import { render, staticRenderFns } from "./subHead.vue?vue&type=template&id=8eecc9e4&scoped=true&"
import script from "./subHead.vue?vue&type=script&lang=js&"
export * from "./subHead.vue?vue&type=script&lang=js&"
import style0 from "./subHead.vue?vue&type=style&index=0&id=8eecc9e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eecc9e4",
  null
  
)

export default component.exports